import React, { useState, useRef, useEffect } from 'react';
import '../styles/AudioPlayer.css';
import { Container, Row, Col, Card, Button, Badge, ListGroup } from 'react-bootstrap';

export default function Sermons(){
  const [currentSermon, setCurrentSermon] = useState(null);
  const playerRef = useRef(null);

  const sermons = [
    {
      id: 1,
      title: 'Jam 2:14-26: Faith Resume',
      date: 'Oct 25, 2026',
      audioUrl:'https://drive.google.com/file/d/1bwy6VqvJHGusPcZ5Caex6oi5U0ZZAmAq/view',
      studyUrl: ''      
    },
    {
      id: 2,
      title: 'Work like a Christian',
      date: 'Oct 18, 2026',
      audioUrl:'https://drive.google.com/file/d/1ai3rdkSazeR_AGtJOh7Kta4C0YONTRtq/view',
      studyUrl: ''  
    },
    {
      id: 3,
      title: 'Jam 2:1-13: Partiality',
      date: 'Oct 11, 2026',
      audioUrl:'https://drive.google.com/file/d/1XQbpcQ3IY--ZIkWJjoHzt9ZEEwR4E5Oj/view',
      studyUrl: ''     
    },
    {
      id: 4,
       title: 'Jam 1:19-27: My precious Bible',
      date: 'Oct 4, 2026',
      audioUrl:'https://drive.google.com/file/d/1SunTCRgrGib6-vUqhK9umtMVM0UT5gP9/view',
      studyUrl: ''   
    }
  ];

  const getDrivePreviewUrl = (url) => {
    try {
      const m = url.match(/\/file\/d\/([^/]+)/);
      const id = m && m[1] ? m[1] : new URL(url).searchParams.get('id');
      if (id) {
        return `https://drive.google.com/file/d/${id}/preview`;
      }
    } catch (_) {}
    return url;
  };

  useEffect(() => {
    if (currentSermon && playerRef.current) {
      try {
        playerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        // ignore scrolling errors
      }
    }
  }, [currentSermon]);

  return (
    <>
      <Container className="px-1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{ color: '#1a3a44', borderRadius: '0', padding: '1.5rem 2rem 2rem', zIndex: 3, fontFamily: "'Nyoetes', 'Sora', 'Space Grotesk', 'Poppins', 'Segoe UI', sans-serif" }}>
          <div className="text-center mb-4">
            <h2 className="fw-bold mb-3" style={{ fontSize: '3.425rem', color: '#c53607f5' }}>Sermons</h2>
            <p className="fs-5" style={{ color: '#1a3a44' }}>Listen to recent messages and teaching from our church.</p>
          </div>

      {/* Featured Sermon Carousel
      <div className="mb-5">
        <h3 className="mb-3 fw-bold" style={{ color: '#e8943a' }}>🌟 Featured Sermon</h3>
        <Carousel className="rounded" style={{ boxShadow: '0 8px 24px rgba(0,0,0,0.15)', borderRadius: '16px', overflow: 'hidden' }}>
          {sermons.slice(0, 3).map((sermon, index) => (
            <Carousel.Item key={sermon.id} interval={5000}>
              <Card style={{ background: 'linear-gradient(135deg, #1a3a44, #78b8d4)', border: 'none', color: '#fff', minHeight: '300px' }} className="d-flex align-items-center justify-content-center">
                <Card.Body className="text-center">
                  <Badge bg={index === 0 ? 'danger' : 'info'} className="mb-3">
                    {index === 0 ? '🆕 New Sermon' : `${index} ${index === 1 ? 'week' : 'weeks'} ago`}
                  </Badge>
                  <Card.Title className="h3 mb-3 fw-bold">{sermon.title}</Card.Title>
                  <Card.Text className="fs-5 mb-4">{sermon.description}</Card.Text>
                  <Button variant="light" onClick={() => setCurrentSermon(sermon)} className="fw-semibold">
                    ▶️ Listen Now
                  </Button>
                </Card.Body>
              </Card>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
      */}
      <Row className="g-4 mb-5">
        {sermons.map((sermon, index) => (
          <Col key={sermon.id} md={6} className="d-flex">
            <Card className="w-100 shadow-sm border-0 border-top border-3" style={{ borderTopColor: index === 0 ? '#e8943a' : '#0d6efd' }}>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <Card.Title className="h5 fw-bold mb-0 flex-grow-1">{sermon.title}</Card.Title>
                  <Badge bg={index === 0 ? 'danger' : 'secondary'} className="ms-2">
                    {index === 0 ? '🆕 New' : `${index} ${index === 1 ? 'week' : 'weeks'} ago`}
                  </Badge>
                </div>
                <Card.Text className="text-muted small mb-3">
                  📅 {sermon.date}
                </Card.Text>
                <ListGroup variant="flush" className="mb-3">
                  <ListGroup.Item className="ps-0 border-0" style={{ background: index === 0 ? '#fff3cd' : '#e7f3ff' }}>
                    <small className="text-secondary fw-semibold">✨ Latest sermons from our series</small>
                  </ListGroup.Item>
                </ListGroup>
                
                <div className="d-flex gap-2 flex-wrap">
                  <Button
                    style={{ background: index === 0 ? '#dc3545' : '#6f42c1' }}
                    size="sm"
                    onClick={() => { setCurrentSermon(sermon); }}
                  >
                    ▶ Play
                  </Button>
                  {sermon.studyUrl && (
                    <Button
                      variant="outline-warning"
                      size="sm"
                      href={sermon.studyUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      📘 Study
                    </Button>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* More Sermons Button */}
      <div className="text-center mb-5">
        <Button 
          href="https://drive.google.com/drive/folders/1wmpGoUTogxyrec3i6SKUW31V70FLDLNy" 
          target="_blank" 
          rel="noopener noreferrer"
          size="lg"
          style={{ background: '#1a3a44', borderColor: '#1a3a44' }}
          className="fw-bold px-5"
        >
          📁 More Sermons
        </Button>
      </div>

      {currentSermon && (
        <Card ref={playerRef} className="shadow-lg border-0 mb-4" style={{ borderTop: '5px solid #e8943a' }}>
          <Card.Header className="d-flex justify-content-between align-items-center py-3" style={{ background: 'linear-gradient(90deg, #f8f9fa, #f0f6ff)' }}>
            <div>
              <Card.Title className="mb-0 fw-bold" style={{ color: '#1a3a44' }}>{currentSermon.title}</Card.Title>
              <small className="text-muted">{currentSermon.date}</small>
            </div>
            <Button 
              variant="outline-secondary"
              size="sm"
              onClick={() => setCurrentSermon(null)}
            >
              ✕ Close
            </Button>
          </Card.Header>
          <Card.Body className="p-0">
            <iframe
              title={`Preview ${currentSermon.title}`}
              src={getDrivePreviewUrl(currentSermon.audioUrl)}
              style={{ width: '100%', height: '400px', border: 0 }}
              allow="autoplay"
            />
          </Card.Body>
        </Card>
      )}
        </div>
      </Container>
    </>
  );
}
